const MESSAGES = {
  en: {
    unavailable: "Protected document access is temporarily unavailable. Please try again.",
    notFound: "This uploaded document is no longer available.",
    generic: "Unable to open this protected document. Please try again."
  },
  ar: {
    unavailable: "الوصول إلى المستند المحمي غير متاح مؤقتًا. يرجى المحاولة مرة أخرى.",
    notFound: "هذا المستند المرفوع لم يعد متاحًا.",
    generic: "تعذر فتح هذا المستند المحمي. يرجى المحاولة مرة أخرى."
  }
};

const STORAGE_UNAVAILABLE_CODES = new Set([
  "PRIVATE_STORAGE_ACCESS_DENIED",
  "PRIVATE_STORAGE_ENVIRONMENT_MISMATCH",
  "PRIVATE_STORAGE_NOT_CONFIGURED",
  "PRIVATE_STORAGE_TEMPORARY_UNAVAILABLE"
]);

const decodeBlobErrorPayload = async (error) => {
  let data = error?.response?.data;
  if (data && typeof data.text === "function") {
    try {
      data = JSON.parse(await data.text());
    } catch (_) {
      return null;
    }
  }
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch (_) {
      return null;
    }
  }
  return data && typeof data === "object" ? data : null;
};

export const protectedDocumentErrorMessage = async (
  error,
  language = "en"
) => {
  const messages = MESSAGES[language === "ar" ? "ar" : "en"];
  const data = await decodeBlobErrorPayload(error);
  const status = Number(error?.response?.status);
  if (data?.code === "PRIVATE_FILE_NOT_FOUND" || status === 404) {
    return messages.notFound;
  }
  if (
    STORAGE_UNAVAILABLE_CODES.has(data?.code) ||
    status === 403 ||
    status >= 500
  ) {
    return messages.unavailable;
  }
  return messages.generic;
};

export default protectedDocumentErrorMessage;
